import { IconButton, Input, InputGroup, InputRightElement } from '@chakra-ui/react'
import { useState } from 'react'
import { Controller } from 'react-hook-form';
import { BsEyeSlash, BsEye } from "react-icons/bs";

const InputPassword = ({ control, name, validateValue, children, color, placeholder }) => {
    const [show, setShow] = useState(false)
    const showHandle = () => setShow(!show)
    const placeholderText = placeholder || "รหัสผ่าน"
    const rules = {
        required: true,
        minLength: 6
    }

    if (validateValue) {
        rules.validate = value => value === validateValue
    }

    return (
        <Controller name={name}
            control={control}
            rules={rules}
            render={({ field }) => {
                if (color) {
                    field = { ...field, color: color }
                }
                return (
                    <InputGroup zIndex={0}>
                        {children}
                        <Input type={show ? "text" : "password"}
                            maxLength={20}
                            placeholder={placeholderText} {...field} />
                        <InputRightElement width="4.5rem">
                            <IconButton size="sm" variant="ghost" onClick={showHandle} icon={show ? <BsEyeSlash /> : <BsEye />} color={color} />
                        </InputRightElement>
                    </InputGroup>

                )
            }}
        />
    )
}

export default InputPassword
